export default __webpack_public_path__ + "static/media/icon-company.e6234149.svg";